module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.orgName),
      expression: "pageInfo.orgName"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索小区名"
    },
    domProps: {
      "value": (_vm.pageInfo.orgName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "orgName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n            搜索\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel pd-025 pb-25"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "card mt-20"
    }, [_c('div', {
      staticClass: "flex-center pd-25 fs-32 bd-bot font-bold"
    }, [_c('div', {
      staticClass: "flex1 mr-20 color-333"
    }, [_vm._v(_vm._s(item.orgName))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.spaceNum != 0),
        expression: "item.spaceNum != 0"
      }],
      staticClass: "color-org"
    }, [_vm._v(_vm._s(item.spaceNum || 0) + "空格")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.spaceNum == 0),
        expression: "item.spaceNum == 0"
      }],
      staticClass: "color-warning"
    }, [_vm._v("已满")])]), _vm._v(" "), _c('div', {
      staticClass: "pd-25"
    }, [_c('div', {
      staticClass: "flex-between fs-28"
    }, [_c('div', {
      staticClass: "flex1 mr-20 color-333"
    }, [_vm._v("寄存柜数：" + _vm._s(item.shopNum || 0))]), _vm._v(" "), _c('div', {
      staticClass: "color-main font-bold"
    }, [_vm._v("待配送：" + _vm._s(item.waitShipOrder || 0))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-30 flex"
    }, [_c('div', {
      staticClass: "btn mr-25 flex1 click",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'lockerOrderList',
            query: {
              orgName: item.orgName,
              orgId: item.orgId
            }
          })
        }
      }
    }, [_vm._v("全部订单")]), _vm._v(" "), _c('div', {
      staticClass: "btn flex1 click",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'lockerHouseDetail',
            query: {
              orgName: item.orgName,
              orgId: item.orgId
            }
          })
        }
      }
    }, [_vm._v("寄存详情")])])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56f38f70","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/lockerHouseList.vue
// module id = KnMG
// module chunks = 51